export const PageComponents = Object.freeze({
    DETAILS: "DETAILS",
    RECOMMENDATIONS: "RECOMMENDATIONS",
    ALTERNATIVES: "ALTERNATIVES",
    ARTICLE_CARD: "ARTICLE_CARD",
    PDP: "PDP",
    SUGGESTIONS: "SUGGESTIONS"
});
export type PageComponent = keyof typeof PageComponents;
